"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Grow_1 = __importDefault(require("@mui/material/Grow"));
var notistack_1 = require("notistack");
var useBreakpoints_1 = require("@hooks/useBreakpoints");
var Toast_1 = require("@components/commons/Toast");
var ToastProvider = function (_a) {
    var children = _a.children;
    var isUnderSm = (0, useBreakpoints_1.useIsUnderSm)();
    return ((0, jsx_runtime_1.jsx)(notistack_1.SnackbarProvider, { maxSnack: 3, anchorOrigin: {
            vertical: isUnderSm ? "bottom" : "top",
            horizontal: "right",
        }, Components: {
            success: Toast_1.Toast,
            error: Toast_1.Toast,
        }, TransitionComponent: Grow_1.default, children: children }));
};
exports.ToastProvider = ToastProvider;
